import React from 'react';

// Placeholder boxes shown while auth / Firestore data is loading.
// The left-to-right shimmer lives in index.css (.skeleton). `compact` matches the
// smaller "Recently Added" tiles; the default matches the main vault cards.
const Bar = ({ className }) => <div className={`skeleton rounded ${className}`} />;

const SkeletonCard = ({ compact }) => (
  <div
    aria-hidden="true"
    className={`bg-surface border border-line rounded-card ${compact ? 'p-3' : 'p-4'}`}
  >
    <div className="flex items-center gap-2 mb-3">
      <Bar className={compact ? 'w-8 h-8' : 'w-10 h-10'} />
      <Bar className="h-4 flex-1 max-w-[60%]" />
    </div>
    <Bar className="h-3 w-full mb-2" />
    <Bar className="h-3 w-4/5 mb-3" />
    {!compact && (
      <div className="flex gap-2">
        <Bar className="h-5 w-14 rounded-chip" />
        <Bar className="h-5 w-16 rounded-chip" />
        <Bar className="h-5 w-12 rounded-chip" />
      </div>
    )}
  </div>
);

/**
 * @param {{ count?: number, compact?: boolean }} props
 */
export default function CardSkeletons({ count = 6, compact = false }) {
  return (
    <>
      <span role="status" className="sr-only">Loading your vault…</span>
      {Array.from({ length: count }, (_, i) => (
        <SkeletonCard key={i} compact={compact} />
      ))}
    </>
  );
}
